// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"af901c437a544d3bd8cf","777":"22a434abbe3f2482b098"}[chunkId] + ".js";
};